import { memo, type CSSProperties } from "react";
import { Box } from "../Box";
import { RewardDialogContent } from "./RewardDialogContent";
import type { WinDialogInfo } from "@/pages/GamePage";
import type { GameTheme } from "@skillscratch/shared-types";
import { TREASURES_TO_WIN } from "@/pages/GamePage";
import { NextGameDialogContent } from "./NextGameDialogContent";
import { useEffect } from "react";
import { useFirebaseFunction } from "@/hooks/useFirebaseFunction";
import { useMemo } from "react";
import { subscribeToNotification } from "@/helpers/subscribeToNotification";
import { unsubscribeToNotification } from "@/helpers/unsubscribeToNotification";

type GetUserPrivateInfoRequest = {
  fields?: string[];
};

type GetUserPrivateInfoResponse = {
  userInfo: {
    lifetimeEarnings: number;
  };
};


const boxStyles: CSSProperties = {
  position: "relative" as const,
  width: "95vw",
  height: "fit-content",
  margin: "0 auto",
  borderRadius: "2vw",
  overflow: "hidden",
};

const getAnimationStyles = (isVisible: boolean): CSSProperties => ({
  transform: isVisible ? undefined : "scale(0.9)",
  opacity: isVisible ? 1 : 0,
  transitionProperty: "transform, opacity",
  transitionDuration: "200ms",
  transitionTimingFunction: "ease-in-out",
});

export const GameEndDialog = memo(function GameEndDialog({
  gameEndReason,
  foundTreasureCount,
  gameTheme,
  // gamePackId,
  // gameSessionId,
  isTutorial,
  onNextGameClick,
  onGoHomeClick,
  // onGameError,
}: {
  winDialogInfo?: WinDialogInfo;
  gameEndReason: string | undefined;
  foundTreasureCount: number;
  gameTheme: GameTheme;
  gamePackId: string;
  gameSessionId: string;
  isTutorial: boolean;
  onNextGameClick(): void;
  onGoHomeClick(): void;
  onGameError(error: Error): void;
}) {
  const [userData, isLoading] = useFirebaseFunction<
    GetUserPrivateInfoRequest, 
    GetUserPrivateInfoResponse
  >(
    'getUserPrivateInfo',
    (fn) => fn({ fields: ["lifetimeEarnings"] }),
    []
  );

  const isWin = gameEndReason === "found-all-treasures" || foundTreasureCount >= TREASURES_TO_WIN;
  const isVisible = !!gameEndReason;
  
  const hasWonMoneyBefore = useMemo(() => {
    return userData?.userInfo.lifetimeEarnings && userData.userInfo.lifetimeEarnings > 0;
  }, [userData?.userInfo.lifetimeEarnings])
  
  useEffect(() => {
    if (isLoading) {
      return;
    }

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowString = tomorrow.toISOString().split('T')[0];

    if (isWin || hasWonMoneyBefore) {
      unsubscribeToNotification(`free_card_${tomorrowString}`);
    } else {
      subscribeToNotification(`free_card_${tomorrowString}`);
    }
  }, [isWin, isLoading, hasWonMoneyBefore]);
  
  if (isWin) {
    return (
      <Box
        style={{
          ...boxStyles,
          ...getAnimationStyles(isVisible),
        }}
      >
        <RewardDialogContent
          onNextGameClick={onNextGameClick}
          onGoHomeClick={onGoHomeClick}
          isTutorial={isTutorial}
          gameTheme={gameTheme}
          foundTreasureCount={foundTreasureCount}
          // gamePackId={gamePackId}
          // gameSessionId={gameSessionId}
          // onGameError={onGameError}
        />
      </Box>
    );
  } 
  
  return (
    // <div className='flex flex-col gap-2'>
    //   <Box
    //     style={{
    //       ...boxStyles,
    //       ...getAnimationStyles(isVisible),
    //     }}
    //     className='bg-red-600 py-4'
    //   >
    //     <span className='text-2xl text-center text-white font-semibold'>1 away from winning $7</span>
    //   </Box>

      <Box
        style={{
          ...boxStyles,
          ...getAnimationStyles(isVisible),
        }}
      >
        <NextGameDialogContent
          onNextGameClick={onNextGameClick}
          onGoHomeClick={onGoHomeClick}
          isTutorial={isTutorial}
          gameTheme={gameTheme}
        />
      </Box>
    // </div>
  );
});